import useGetMLInferredRole from 'bundles/onboarding-common/hooks/useGetMLInferredRole';
import useGetPathwaysInferredRole from 'bundles/onboarding-common/hooks/useGetPathwaysInferredRole';
import useOccupationPreferencesData from 'bundles/onboarding-common/hooks/useOccupationPreferencesData';
import type { RoleFragment } from 'bundles/onboarding-common/queries/__generated__/RoleFragment';
import { getShouldUseMLInferredRole } from 'bundles/onboarding-common/utils/experimentUtils';
import showDefaultPathwaysInferredRole from 'bundles/onboarding-common/utils/showDefaultPathwaysInferredRole';

type UseGetDefaultInferredRoleReturn = {
  inferredRole: Pick<RoleFragment, 'id' | 'name'> | undefined;
  inferredRoleLoading: boolean;
};

const useGetDefaultInferredRole = ({ skip }: { skip: boolean }): UseGetDefaultInferredRoleReturn => {
  const { value: userSavedRoles, loading: userSavedRolesLoading } = useOccupationPreferencesData({
    skip,
  });
  const hasUserSavedRoles = !userSavedRolesLoading && !!userSavedRoles && userSavedRoles.length > 0;
  const skipInferredRoleQueries = skip || userSavedRolesLoading || hasUserSavedRoles;

  const shouldUseMLInferredRole = getShouldUseMLInferredRole();
  const skipPathwaysInferredRole =
    skipInferredRoleQueries || shouldUseMLInferredRole || !showDefaultPathwaysInferredRole();
  const skipMLInferredRole = skipInferredRoleQueries || !shouldUseMLInferredRole;

  const { pathwaysInferredRole, pathwaysInferredRoleLoading } = useGetPathwaysInferredRole({
    skip: skipPathwaysInferredRole,
  });
  const { mlInferredRole, mlInferredRoleLoading } = useGetMLInferredRole({ skip: skipMLInferredRole });

  const inferredRole = shouldUseMLInferredRole ? mlInferredRole : pathwaysInferredRole;
  const inferredRoleLoading = shouldUseMLInferredRole ? mlInferredRoleLoading : pathwaysInferredRoleLoading;

  return {
    inferredRole,
    inferredRoleLoading: userSavedRolesLoading || inferredRoleLoading,
  };
};

export default useGetDefaultInferredRole;
